import { Hexagon, Instagram, Twitter, Youtube } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Hexagon className="w-6 h-6 text-[#007AFF]" strokeWidth={1.6} />
              <span className="font-heading text-3xl tracking-wider">GRIPFORCE<span className="text-[#007AFF]">X</span></span>
            </div>
            <p className="text-sm text-white/55 max-w-sm leading-relaxed">
              Engineered grip-strength hardware for athletes who refuse to plateau.
              Designed in Tokyo. Built worldwide.
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4 font-body">Product</div>
            <ul className="space-y-3 text-sm text-white/70 font-body">
              <li><a href="#features" className="hover:text-[#007AFF] transition">Features</a></li>
              <li><a href="#specs" className="hover:text-[#007AFF] transition">Specifications</a></li>
              <li><a href="#buy" className="hover:text-[#007AFF] transition">Order</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4 font-body">Company</div>
            <ul className="space-y-3 text-sm text-white/70 font-body">
              <li><a href="#" className="hover:text-[#007AFF] transition">Manifesto</a></li>
              <li><a href="#" className="hover:text-[#007AFF] transition">Athletes</a></li>
              <li><a href="#" className="hover:text-[#007AFF] transition">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-8 border-t border-white/10">
          <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 font-body">
            © 2026 GripForce X · All Rights Reserved
          </div>
          <div className="flex items-center gap-5">
            {[Instagram, Twitter, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="text-white/55 hover:text-[#007AFF] transition" data-testid={`social-${i}`}>
                <Icon className="w-4 h-4" strokeWidth={1.6} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
